/** @type {import('../help-index.js').HelpScreen} */
export const MEL_PUB_HELP = {
  screenId: 'mel-pub',
  label: 'Publicaciones',
  navPath: 'MercadoLibre → Publicaciones',
  keywords: ['publicaciones', 'items', 'listados', 'mercado libre', 'mercadolibre'].map((k) => k.toLowerCase()),
  status: 'draft',
  summary: 'Listado y consulta de publicaciones activas en MercadoLibre.',
  sidebarItems: [{
    id: 'mel-pub',
    screenId: 'mel-pub',
    label: 'Publicaciones',
    description: 'Consultar publicaciones activas, filtrar por estado y ver detalle.',
    detail: {
      sections: [
        {
          title: 'Para qué sirve',
          intro: 'Muestra todas las publicaciones del vendedor en MercadoLibre con su estado, precio y stock.',
        },
        {
          title: 'Filtros disponibles',
          bullets: [
            'Estado: activa, pausada, en revisión, cerrada, inactiva.',
            'SKU: buscar por código interno del producto.',
          ],
        },
        {
          title: 'Acciones',
          bullets: [
            'Hacer clic en una fila para ver el detalle completo de la publicación.',
          ],
        },
      ],
    },
  }],
}
